const initialState = {
  newOrganizationRegionForm: false,
  region: '',
};
export default initialState;
